import { alpha } from "@mui/material";
import type { Theme } from "@mui/material/styles";

/**
 * Shared outlined-input focus ring style used by TeamsTab dialogs.
 */
export const focusRingSx = (theme: Theme) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 1,
    transition: "all 150ms ease",
    "& fieldset": { borderColor: alpha(theme.palette.text.primary, 0.12) },
    "&:hover fieldset": { borderColor: alpha(theme.palette.primary.main, 0.5) },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}, 0 0 0 4px ${alpha(theme.palette.primary.main, 0.2)}`,
    },
  },
});
